// @flow
import React, { FC, useEffect, useState } from 'react';
import api from '@api';
import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { UserType } from 'src/types/user';
import { styled } from '@mui/system';
import { colors } from 'src/themes/default';
import { AvatarIcon } from '../SkladonIcon/Icons';

export interface UserAvatarProps {
    user: UserType;
}

const AvatarComponnent = styled(Avatar)<AvatarProps>(({ theme }) => ({
    width: '38px',
    height: '38px',
    marginLeft: '10px',
    background: 'unset',

    '& .MuiSvgIcon-root': {
        height: '38px',
        width: '38px',
        color: colors.text_T3,
    },
}));

const UserAvatar: FC<UserAvatarProps> = (props) => {
    const [srcData, setSrcData] = useState<string | null>(null);

    useEffect(() => {
        if (props.user?.USER_ID) {
            getApiData();
        }
    }, [props.user]);

    const getApiData = async () => {
        const response: { data: string } = await api('get', `api/secure/users/photo/${props.user.USER_ID}`);
        setSrcData(response.data);
    };

    if (srcData) {
        return (
            <AvatarComponnent alt={`${props.user.NAME} ${props.user.SURNAME}`} src={srcData}>
                <AvatarIcon />
            </AvatarComponnent>
        );
    }

    return (
        <AvatarComponnent alt={`${props.user.NAME} ${props.user.SURNAME}`}>
            <AvatarIcon />
        </AvatarComponnent>
    );
};

export default UserAvatar;
